import { jsxs, Fragment, jsx } from 'react/jsx-runtime';
import { UserProfile } from '../../../../components/UserProfile/UserProfile.js';
import { DynamicWidgetFooter } from '../../components/DynamicWidgetFooter/DynamicWidgetFooter.js';
import 'react';
import { classNames } from '../../../../utils/functions/classNames/classNames.js';
import '@dynamic-labs/sdk-api';
import '../../../../shared/logger.js';
import '@dynamic-labs/iconic';
import '@dynamic-labs/multi-wallet';
import '../../../../context/ViewContext/ViewContext.js';
import { ReactComponent as SvgPencil } from '../../../../shared/assets/pencil.js';
import '../../../../utils/constants/colors.js';
import '../../../../shared/consts/index.js';
import { useInternalDynamicContext } from '../../../../context/DynamicContext/useInternalDynamicContext.js';
import { getEnabledKYC } from '../../../../utils/functions/getEnabledKYC/index.js';
import '../../../../components/ShadowDOM/ShadowDOM.js';
import '../../../../context/ThemeContext/ThemeContext.js';
import 'react-dom';
import 'react-focus-lock';
import '../../../../components/Transition/ZoomTransition/ZoomTransition.js';
import '../../../../components/Transition/SlideInUpTransition/SlideInUpTransition.js';
import '../../../../components/Transition/OpacityTransition/OpacityTransition.js';
import '../../../../config/ApiEndpoint.js';
import '../../../../context/ErrorContext/ErrorContext.js';
import 'ethers';
import '../../../../context/MockContext/MockContext.js';
import '../../../../context/CaptchaContext/CaptchaContext.js';
import '../../../../utils/hooks/useUserUpdateRequest/useUserUpdateRequest.js';
import { Button } from '../../../../components/Button/Button.js';
import '../../../../components/IconButton/IconButton.js';
import { LogoutButton } from '../../../../components/LogoutButton/LogoutButton.js';
import { useWidgetContext } from '../../context/DynamicWidgetContext.js';

const ProfileView = () => {
    var _a;
    const { setDynamicWidgetView } = useWidgetContext();
    const { projectSettings } = useInternalDynamicContext();
    const userFields = (_a = getEnabledKYC(projectSettings === null || projectSettings === void 0 ? void 0 : projectSettings.kyc)) === null || _a === void 0 ? void 0 : _a.filter((setting) => setting.name !== 'social');
    return (jsxs(Fragment, { children: [jsx(UserProfile, { rootClassName: 'profile-view' }), jsx(DynamicWidgetFooter, { children: jsxs("div", Object.assign({ className: 'profile-view__footer' }, { children: [(userFields === null || userFields === void 0 ? void 0 : userFields.length) > 0 && (jsx(Button, Object.assign({ buttonClassName: 'dynamic-widget-footer__button', buttonVariant: 'tertiary', buttonPadding: 'none', typographyProps: {
                                color: 'secondary',
                                variant: 'button_tertiary',
                            }, onClick: () => setDynamicWidgetView('edit-profile'), startSlot: jsx(SvgPencil, {}) }, { children: "Edit profile" }))), jsx(LogoutButton, { isTextButton: true, buttonClassName: classNames('dynamic-widget-footer__button', {
                                'dynamic-widget-footer__button-align-right': !(userFields === null || userFields === void 0 ? void 0 : userFields.length),
                            }) })] })) })] }));
};

export { ProfileView };
